"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _Label = _interopRequireDefault(require("../../text/Label"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledLabel = (0, _styledComponents["default"])(_Label["default"]).withConfig({
  componentId: "sc-54gf9v-0"
})(["display:flex;align-items:center;font-weight:normal;height:", "px;width:", ";> span{width:100%;}span{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}"], function (props) {
  return props.size;
}, function (props) {
  return props.fixedWidth || '100%';
});
StyledLabel.displayName = 'StyledLabel';

function Checkbox(_ref) {
  var id = _ref.id,
      className = _ref.className,
      disabled = _ref.disabled,
      name = _ref.name,
      label = _ref.label,
      iconName = _ref.iconName,
      checked = _ref.checked,
      color = _ref.color,
      size = _ref.size,
      fixedWidth = _ref.fixedWidth,
      value = _ref.value,
      onChange = _ref.onChange;
  return _react["default"].createElement(StyledLabel, {
    title: label,
    className: className,
    size: size,
    fixedWidth: fixedWidth,
    subdued: true
  }, _react["default"].createElement(_pclnDesignSystem.Checkbox, {
    id: id,
    disabled: disabled,
    defaultChecked: checked,
    name: name,
    color: color,
    size: size,
    value: value,
    onChange: onChange
  }), _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: iconName,
    size: 18,
    mr: 1
  }), _react["default"].createElement("span", null, label));
}

Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  id: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  label: _propTypes["default"].node,
  iconName: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  size: _propTypes["default"].number,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  fixedWidth: _propTypes["default"].string
};
Checkbox.defaultProps = {
  className: '',
  color: 'primary',
  size: 24,
  onChange: function onChange() {
    return null;
  }
};

var _default = (0, _react.memo)(Checkbox);

exports["default"] = _default;